<script setup>
import { storeToRefs } from 'pinia';
import { useEventStore } from '../stores/event-store';
import EventNavComponent from '../components/EventNavComponent.vue';
import { usePermissions } from '../../../auth/composables/permissions';
import defaultLogo from '../../../app/assets/event_logo.png';
import defaultCoverPhoto from '../../../app/assets/event_cover_photo.png';

/**
 * Permissions
 */
const { isAllowed } = usePermissions();

/**
 * Events
 */
const { event, loading } = storeToRefs(useEventStore());
</script>

<template>
  <div class="container">
    <div class="event-images" v-if="!loading && event">
      <div class="event-cover-photo d-flex justify-content-center align-items-center overflow-hidden">
        <img :src="event?.coverPhoto ?? defaultCoverPhoto" class="w-100 h-100 object-fit-cover" alt="Event Cover Photo">
      </div>
      <div class="event-logo d-flex justify-content-center align-items-center overflow-hidden">
        <img :src="event?.logo ?? defaultLogo" class="w-100 h-100 object-fit-cover" alt="Event Logo">
      </div>
    </div>
    <div class="row my-3 align-items-center" v-if="!loading && event">
      <div class="col">
        <h2 class="m-0">{{ event.name }}</h2>
      </div>
      <div class="col-12 col-md-auto">
        <RouterLink :to="{
          name: 'event.manage.detail',
        }" class="btn btn-primary mt-3 ms-md-1 w-100" v-if="isAllowed('event.manage.detail', event.security)">
          Manage Event
        </RouterLink>
      </div>
    </div>

    <EventNavComponent />

    <div class="alert alert-warning" role="alert" v-if="!loading && event && event.approved === 0">
      This event is pending apprvoal from {{ event.leagueName }}
    </div>

    <RouterView />
  </div>
</template>

<style scoped>
.event-cover-photo {
  max-height: 200px;
}

@media (min-width: 576px) {
  .event-cover-photo {
    max-height: 200px;
  }
}

@media (min-width: 768px) {
  .event-cover-photo {
    max-height: 300px;
  }
}

@media (min-width: 992px) {
  .event-cover-photo {
    max-height: 400px;
  }
}

@media (min-width: 1200px) {
  .event-cover-photo {
    max-height: 500px;
  }
}

.event-images {
  position: relative;
}

.event-logo {
  max-width: 100px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  margin-bottom: 1rem;
  margin-left: 1rem;
  border: 3px solid #000;
}

@media (min-width: 576px) {
  .event-logo {
    max-width: 100px;
  }
}

@media (min-width: 768px) {
  .event-logo {
    max-width: 150px;
  }
}

@media (min-width: 992px) {
  .event-logo {
    max-width: 200px;
  }
}
</style>
